
export const setBranchList = (branches) => ({
  type: 'BRANCHES',
  branches
});